import React from "react";
import { Link } from "react-router-dom";

export default function FooterLink({ link, text }) {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // window.location.reload();
  };

  return (
    <>
      <li>
        <Link onClick={scrollTop} to={link}>
          {text}
        </Link>
      </li>
    </>
  );
}
